var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "button-edit py-2 px-4"
  }, [_c('v-text-field', {
    staticClass: "pt-5",
    attrs: {
      "hide-details": "",
      "label": _vm.$t('iframeedit_iframe_url')
    },
    on: {
      "input": function input($event) {
        return _vm.updateUrl();
      }
    },
    model: {
      value: _vm.iframeUrl,
      callback: function callback($$v) {
        _vm.iframeUrl = $$v;
      },
      expression: "iframeUrl"
    }
  }), _c('v-text-field', {
    attrs: {
      "type": "number",
      "hint": _vm.$t('iframeedit_iframe_height_hint'),
      "persistent-hint": "",
      "placeholder": _vm.$t('iframeedit_iframe_height_placeholder'),
      "label": _vm.$t('iframeedit_iframe_height')
    },
    on: {
      "input": function input($event) {
        return _vm.updateHeight();
      }
    },
    model: {
      value: _vm.iframeHeight,
      callback: function callback($$v) {
        _vm.iframeHeight = $$v;
      },
      expression: "iframeHeight"
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }